import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect', '/avoid-login', '/500'] // no redirect whitelist

const hideSiderBarList = [
  '/index/dashboard',
  '/',
  '/enterprise-agreement/agreement-list',
  '/no-permission/index'
]
const exceptErrorList = ['/custom-screen-page']

router.beforeEach(async (to, from, next) => {
  console.log('to', to)
  if (to.path === '/avoid-login') {
    // in the free login whitelist, go directly
    next()
    return
  }
  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  if (hideSiderBarList.indexOf(to.path) > -1) {
    store.dispatch('app/toggleDevice', 'mobile')
    store.dispatch('app/closeSideBar', { withoutAnimation: true })
  } else {
    if (!$_isMobile()) {
      store.dispatch('app/openSideBar')
      store.dispatch('app/toggleDevice', 'desktop')
    }
  }
  if (to.path === '/500') {
    next()
  }
  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else {
      if (store.getters.checkPermission) {
        if (to.path === '/') {
          const accessedRoutesArr = store.state.permission.accessedRoutes
          const item = accessedRoutesArr.find((item) => !item.hidden)
          if (from.path === '/index') {
            // next({ ...to, path: item.path, replace: true })
            location.reload()
          } else {
            if (item) {
              next({ ...to, path: item.path, replace: true })
            } else {
              next()
            }
          }
        } else {
          next()
        }
      } else {
        try {
          const data = await store.dispatch(
            'user/siteProjectQueryByCurrentUser',
            {}
          )
          const accessedRoutes = await store.dispatch(
            'permission/queryResourceByUser',
            { businessId: data.projectItem.projectId }
          )

          await store.dispatch('user/getAgreementList', {
            projectId: data.projectItem.projectId
          })
          store.dispatch('user/queryByDomain', {
            businessId: data.projectItem.projectId
          })
          // const accessedRoutes = await store.dispatch('permission/queryResourceByUser', { })
          store.dispatch('socket/initSocket')
          store.dispatch('user/getUserInfo', {})
          if (data.data.length > 0) {
            router.addRoutes(accessedRoutes)
          }

          if (store.state.permission.resourceList.length <= 0) {
            next({ path: '/no-permission/index' })
            return
          } else {
            if (to.path === '/no-permission/index') {
              next({ path: '/' })
              return
            }
          }

          // if (store.getters.projectItem.projectId) {
          if (to.path === '/') {
            const item = accessedRoutes.find((item) => !item.hidden)
            if (item) {
              next({ ...to, path: item.path, replace: true })
            } else {
              next({ ...to, replace: true })
            }
          } else {
            next({ ...to, replace: true })
          }
          // } else {
          //   next({ path: '/map' })
          // }
        } catch (error) {
          console.log(error.code)
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error')
          // next(`/login?redirect=${to.fullPath}`)
          if (exceptErrorList.indexOf(to.path) === -1) {
            next(`/500`)
          }
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.fullPath}`)
      NProgress.done()
    }
  }
})

function $_isMobile() {
  const { body } = document
  const rect = body.getBoundingClientRect()
  return rect.width - 1 < 992
}

function setChildrenRoute(to) {
  const accessedRoutesArr = store.state.permission.routes
  if ($_isMobile()) {
    store.commit('permission/SET_CHILDREN_ROUTES', accessedRoutesArr)
    return
  }
  const pathArr = to.path.split('/')
  pathArr.splice(0, 1)
  const childrenRoute = accessedRoutesArr.find((item) => {
    return item.path === '/' + pathArr[0]
  }) || { children: [] }
  store.commit('permission/SET_CHILDREN_ROUTES', childrenRoute.children)
}

router.afterEach((to) => {
  // finish progress bar
  NProgress.done()
  setChildrenRoute(to)
})
